import { useContext, useEffect, useState } from 'react';
import authContext from '../../../../contexts/authContext';
import { getToken } from '../../../../services/user-info.service';
import { getPointsByUser } from '../../../../services/user-info.service';

type UsePointsType = {
    notifyPoints: (points: number) => void;
}

const usePoints = ({notifyPoints}:UsePointsType) => {
    const [userPoints, setUserPoints] = useState<number | null>(null);
    const auth = useContext(authContext);
	const [token, setToken] = useState<string | null>();

	useEffect(() => {
		if (!auth.gigyaAccount) {
			return;
		}
		const obtenerToken = async (uid: string) => {
			const resToken = await getToken(uid);
			setToken(resToken);
		}
		obtenerToken(auth.gigyaAccount?.UID);
	}, [auth.gigyaAccount]);


    const getPoints = async () => {
		try {
			const points = await getPointsByUser();
			if (userPoints !== null && userPoints !== Number(points.data.data)) {
				const newPoints = Number(points.data.data) - userPoints;
				if (!isNaN(newPoints) && newPoints > 0) {
					notifyPoints(newPoints);
				}
			}
			setUserPoints(isNaN(Number(points.data.data)) ? 0 : Number(points.data.data));
		} catch (error) {
			console.error("Error al obtener puntos de usuario.");
		}
	};

  return {
    userPoints,
    getPoints
  }
}

export default usePoints